import { applySessionNav } from '../lib/nav.js';

// Giriş yapmış kullanıcı için "Hemen başla" akrabalarım sayfasına gider, tekrar kayıt/giriş istenmez.
const s = await applySessionNav();
const cta = document.querySelector<HTMLAnchorElement>('a.btn[href="/kayit.html"]');
if (s && cta) { cta.href = '/akrabalarim.html'; cta.textContent = 'Akrabalarıma git'; }

// Anlatım animasyonu sürekli döngüdür; ekran dışına çıkınca boşuna çizim yapmasın.
const scenes = document.querySelectorAll<HTMLElement>('.ha-h, .ha-v');
if (scenes.length > 0 && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver(
    (entries) => { for (const e of entries) e.target.classList.toggle('is-idle', !e.isIntersecting); },
    { rootMargin: '120px' },
  );
  for (const el of scenes) io.observe(el);
}
